import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useLayout } from '~hooks/useLayout';
import { useSeo } from '~hooks/useSeo';

import Hero from '~components/hero';
import FullLoader from '~components/loader/full-loader';

const AccessDenied = () => {
  const intl = useIntl();
  const [afterTimeout, setAfterTimeout] = useState(false);

  useSeo(
    intl.formatMessage({
      id: 'containers.access-denied.title',
      defaultMessage: '403 - Access Denied',
    })
  );

  useLayout({ displayCities: false });

  useEffect(() => {
    setTimeout(() => setAfterTimeout(true), 1000);
  }, [])

  if(!afterTimeout) {
    return <FullLoader />
  }

  return (
    <div className="c-account__main l-container l-mt2">
      <Hero.Wrapper>
        <Hero.Title>{intl.formatMessage({ id: 'containers.access-denied.headline', defaultMessage: 'Access denied' })}</Hero.Title>
        <Hero.Intro>
          {intl.formatMessage({
            id: 'containers.access-denied.content',
            defaultMessage: 'You have insufficient permissions to view this page.',
          })}
        </Hero.Intro>
      </Hero.Wrapper>
    </div>
  )
};

export default AccessDenied;
